import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AccountService, AlertService, ConnectionService } from '@app/_services';
import { environment } from '../../environments/environment';
import {  NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ForgetPasswordComponent } from '../forgetpassword.component';

@Component({ templateUrl: 'login.component.html' })
export class LoginComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  siteKey: string;
  ch = false;
  chcount: number = 0;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private alertService: AlertService,
    private con: ConnectionService,    
    private modalService: NgbModal

  ) { this.siteKey = environment.sitekey }

  ngOnInit() {

    this.form = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
      //  recaptcha: ['', Validators.required]
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    localStorage.clear();
    this.accountService.login(this.f.username.value, this.f.password.value)
      .pipe(first())
      .subscribe(
        data => {
          if (data.wrong_attempt >= 3) {
            if (!this.ch) {
              this.ch = true;

              this.form = this.formBuilder.group({
                username: ['', Validators.required],
                password: ['', Validators.required],
                recaptcha: ['', Validators.required]
              });
            }

          }
          if (data && data.isSuccess==true) {
            //this.router.navigate([this.returnUrl]);
            sessionStorage.setItem("uId", data.uId.toString());
            this.router.navigate([`/connection/automation/${data.uId}`]);
          } else {
            this.alertService.error(data.message);
            this.loading = false;
          }

        },
        error => {
          if (error == "Unauthorized")
            error = "Invalid email or password.";
          this.alertService.error(error);
          this.loading = false;
        });
  }

  sendTest(){
    this.con.PostChatMessage()
  }
  

  openForgetPasswordDialog(): void {   
    
    const modalRef = this.modalService.open(ForgetPasswordComponent, {
       backdrop: 'static', 
      keyboard: false,      
    });
    //(<ForgetPasswordComponent>modalRef.componentInstance).data = {
    //  ClientId: this.IsClientId,
    //  ClientConnectorsList: response
    //}

    //modalRef.result.then((result) => {
    //  if (this.CustomerDetail && result.data) {
    //    this.ConnectorsBindingArray = result.data;
    //    this.GetConnectionsList(this.CustomerDetail.ClientId, false);
    //  }
    //});
  }

}
